import {
  Autocomplete,
  Avatar,
  Backdrop,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  Grid,
  InputLabel,
  List,
  ListItem,
  Paper,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import HeadingCard from "../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import FilterButtonComponent from "../../newTestPrep/newComponent/NewButtonComp/FilterButtonComponent";
import CampaignDetailedReport from "./CampaignDetailedReport";
import UserWiseCampaignReport from "./UserWiseCampaignReport";
import CampaignWiseReport from "./CampaignWiseReport";

export default function CamPaignAllReport() {

  const [selectedChip, setSelectedChip] = useState("detailedreport");

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      selectedChip === "userwisereport" ||
      selectedChip === "campaignwise" ||
      selectedChip === "eventattendees"
    ) {
      setOpen(true);
    }
  }, [selectedChip]);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleChipClick = (criteria) => {
    setSelectedChip(criteria);
    setOpen(false);
  };


  return (
 <Grid Grid container spacing={2}>
        <Grid item xs={12} lg={2} sm={4} md={3}>
                  <HeadingCard>
                    <Typography variant="h3" textAlign="center">
                      {" "}
                    Campaign  Report
                    </Typography>
                  </HeadingCard></Grid>
        
        <Grid item xs={12} md={12} sm={12} lg={12}>
          <Grid container>
            <Grid item xs={12} md={8} sm={12} lg={8}>
              <Grid container gap={2}>
                <Button
                  size="small"
                  style={{
                    fontWeight: selectedChip === "detailedreport" ? 600 : 500,
                    background:
                      selectedChip === "detailedreport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedChip !== "detailedreport" ? "#364152" : "white",
                    border:
                      selectedChip !== "detailedreport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("detailedreport")}
                >
                  Detailed Report
                </Button>

                <Button
                  size="small"
                  style={{
                    fontWeight: selectedChip === "userwisereport" ? 600 : 500,
                    background:
                      selectedChip === "userwisereport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedChip !== "userwisereport" ? "#364152" : "white",
                    border:
                      selectedChip !== "userwisereport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("userwisereport")}
                >
                  User Wise Specific Report
                </Button>

                <Button
                  size="small"
                  style={{
                    fontWeight: selectedChip === "campaignwise" ? 600 : 500,
                    background:
                      selectedChip === "campaignwise" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedChip !== "campaignwise" ? "#364152" : "white",
                    border:
                      selectedChip !== "campaignwise"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("campaignwise")}
                >
                  Campaign Wise Specific Report
                </Button>

               

              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              sm={12}
              lg={4}
              display="flex"
              justifyContent="flex-end"
            >
              <FilterButtonComponent
                onClick={handleToggle}
                text="Filter"
                open={open}
                showendIcon={true}
              />
            </Grid>
          </Grid>
        </Grid>

<Grid item xs={12}>
        {selectedChip === "detailedreport" && <CampaignDetailedReport open={open} />}
      {selectedChip === "userwisereport" && <UserWiseCampaignReport open={open} /> }
        {selectedChip === "campaignwise" && <CampaignWiseReport open={open} />}
       
        </Grid>
      </Grid>
  )
}
